/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import React, { useState, useRef } from "react";
import {
  Col,
  Row,
  Form,
  Button,
  ButtonGroup,
  InputGroup,
  Dropdown,
} from "react-bootstrap";
import { CheckIcon } from "@heroicons/react/solid";

import { useBreakpoint } from "@vlinder-web/breakpoint-hook-widget-react";

export interface ISettingsCompProps {
  searchPlaceholderText?: string;
  searchStatusFilter?: {
    value: string;
    label: string;
  }[];
  typeOfSearch?: {
    value: string;
    label: string;
  }[];
  onSearchValue?(name: string): void;
  onStatusFilter?(value: string): void;
  settingsEntriesLabel?: string;
  onApplyFilter?(filterData: any, status: any): void;
  onClearFilter?(): void;
  applyLabel?: string;
  clearLabel?: string;
  typeStyle?: any;
  settingsEntries?: {
    value: string;
    label: string;
  }[];
  onSettingEntryChange(value: string): void;
}

export const SettingsComp = ({
  searchPlaceholderText,
  searchStatusFilter,
  typeOfSearch,
  applyLabel,
  clearLabel,
  typeStyle,
  onSettingEntryChange,
  onApplyFilter,
  onClearFilter,
}: ISettingsCompProps) => {
  const breakpoint = useBreakpoint();
  const [searchValue, setSearchValue] = useState("");
  const [statusFilter, setStatusFilter] = useState();
  const [settingEntry, setSettingEntry] = useState("10");
  const [typeFilter, setTypeFilter] = useState("fullName");
  const [disableApply, setDisableApply] = useState(true);

  const changeSearchValue = (e) => {
    let newSearchValue = e.target.value;
    if (typeFilter === "email") {
      newSearchValue = e.target.value.trim();
    }
    setSearchValue(newSearchValue);
    setDisableApply(false);
    // if (onSearchValue) {
    //   onSearchValue(newSearchValue?.toLowerCase());
    // }
  };

  const getButtonMargin = () => {
    let _style: any = {};
    if (breakpoint === "xs" || breakpoint === "sm") {
      _style.marginTop = "15px";
    }
    return _style;
  };

  const changeTypeFilter = (e) => {
    console.log(`on change type`, e);
    const newTypeFilter = e.target.value;
    setTypeFilter(newTypeFilter);
  };

  const _getStatus = (status: string) => {
    switch (status) {
      case "active":
        return "USER_ACC_CREATED";
      case "invited":
        return "USER_INVITED";
      case "verified":
        return "USER_VERIFIED";
      case "created":
        return "USER_ADDED";
      case "suspended":
        return "SUSPENDED";
      default:
        return null;
    }
  };

  const applyFilterAction = () => {
    let _data: any = {};
    if (typeFilter && searchValue) {
      _data[typeFilter] = searchValue;
    }
    // _data.accountStatus = _getStatus(statusFilter);
    let status = _getStatus(statusFilter);

    onApplyFilter && onApplyFilter(_data, status);
  };

  const changeStatusFilter = (e) => {
    console.log(`change value`, e.target.value);
    const newStatusFilter = e.target.value;
    setStatusFilter(newStatusFilter);
    setDisableApply(false);
    // if (onStatusFilter) {
    //   onStatusFilter(newStatusFilter);
    // }
  };

  const changeSettingEntry = (e) => {
    setSettingEntry(e);
    if (onSettingEntryChange) {
      onSettingEntryChange(e);
    }
  };

  const clearFilter = () => {
    setSearchValue("");
    setStatusFilter(null);
    setDisableApply(true);
    onClearFilter && onClearFilter();
  };

  const _getCheckIcon = (value: any) => {
    if (value && value === settingEntry) {
      return <CheckIcon className="icon icon-xxs ms-auto" />;
    }
    return <></>;
  };

  return (
    <div className="table-settings mb-4">
      <Row className="justify-content-between align-items-center">
        <Col xs={12} lg={8} className="d-md-flex">
          <InputGroup className="me-2 me-lg-4 fmxw-500">
            <Form.Select
              value={typeFilter}
              style={typeStyle}
              // className="fmxw-150 d-none d-md-inline"
              onChange={changeTypeFilter}
            >
              {typeOfSearch?.map((status, index) => (
                <option
                  key={`option-${status?.value}-${index}`}
                  value={status?.value}
                >
                  {status?.label}
                </option>
              ))}
            </Form.Select>
            <Form.Control
              type="text"
              placeholder={searchPlaceholderText}
              value={searchValue}
              onChange={changeSearchValue}
            />
          </InputGroup>
          {/* <Form.Select
            value={statusFilter}
            className="fmxw-200 d-none d-md-inline"
            onChange={changeStatusFilter}
          >
            {searchStatusFilter?.map((status, index) => (
              <option
                key={`option-${status?.value}-${index}`}
                value={status?.value}
              >
                {status?.label}
              </option>
            ))}
          </Form.Select> */}
          <Button
            variant="secondary"
            size="sm"
            className="ms-3"
            disabled={disableApply}
            onClick={applyFilterAction}
            style={getButtonMargin()}
          >
            {applyLabel}
          </Button>
          {!disableApply ? (
            <Button
              variant="primary"
              size="sm"
              className="ms-3"
              onClick={clearFilter}
              style={getButtonMargin()}
            >
              {clearLabel}
            </Button>
          ) : null}
        </Col>
      </Row>
    </div>
  );
};

SettingsComp.defaultProps = {
  searchPlaceholderText: "Search users by Name",
  settingsEntriesLabel: "Show",
  applyLabel: "Apply",
  clearLabel: "Clear",
  typeStyle: {
    maxWidth: "140px",
  },
};
